import React, { useEffect } from "react";
import DashboardCard from "./DashboardCard/DashboardCard";
import ProjectChart from "./DonutCard/DonutCard";
import InspectorData from "./InspectorData/InspectorData";
import { useDispatch, useSelector } from "react-redux";
import { GetDashboardDetails } from "../../../redux/action/DashbardAction/DashboardAction";
import BlueBag from "../../../asesst/BlueBag.svg";
import YellowBag from "../../../asesst/YellowBag.svg";
import GreenBag from "../../../asesst/GreenBag.svg";
import RedBag from "../../../asesst/RedBag.svg";
import WeldingOperatorStatics from "./WeldingStatics/WeldingOperatorStatics";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { error, isLoading, dashboardDetails } = useSelector(
    (state) => state.dashboard,
  );
  useEffect(() => {
    dispatch(GetDashboardDetails());
  }, [dispatch]);

  if (isLoading) {
    return (
      <>
        <span className="animate-spin">⌛</span>
        Loading...
      </>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  const cardData = [
    {
      icon: <img src={BlueBag} alt="Icon 1" className="w-6 h-6" />,
      value: dashboardDetails?.totalInspector,
      label: "Total Inspectors",
      color: "bg-slate-100",
    },
    {
      icon: <img src={GreenBag} alt="Icon 2" className="w-6 h-6" />,
      value: dashboardDetails?.activeInspector,
      label: "Active Inspectors",
      color: "bg-emerald-50",
    },
    {
      icon: <img src={RedBag} alt="Icon 3" className="w-6 h-6" />,
      value: dashboardDetails?.inactiveInspector,
      label: "Inactive Inspectors",
      color: "bg-rose-50",
    },
    {
      icon: <img src={YellowBag} alt="Icon 4" className="w-6 h-6" />,
      value: dashboardDetails?.totalProject,
      label: "Total Projects",
      color: "bg-amber-50",
    },
  ];
  return (
    <div className="flex-1 bg-slate-50 rounded-xl p-4 sm:p-6">
      <h2 className="text-2xl sm:text-3xl font-semibold text-slate-800 mb-6">
        Dashboard
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cardData.map((card, index) => (
          <DashboardCard
            key={index}
            icon={card.icon}
            value={card.value}
            label={card.label}
            color={card.color}
          />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-14">
        <div className="p-5 bg-white border border-slate-200 shadow-sm rounded-xl">
          <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">
            Projects
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ProjectChart
              title="Assigned"
              percentage={parseFloat(
                (
                  (dashboardDetails?.assignedProject /
                    dashboardDetails?.totalProject) *
                  100
                ).toFixed(0),
              )}
              color="#3B82F6"
              dimesioning="#DBEAFE"
            />
            <ProjectChart
              title="Ongoing"
              percentage={parseFloat(
                (
                  (dashboardDetails?.ongoingProject /
                    dashboardDetails?.totalProject) *
                  100
                ).toFixed(0),
              )}
              color="#F59E0B"
              dimesioning="#FEF3C7"
            />
            <ProjectChart
              title="Completed"
              percentage={parseFloat(
                (
                  (dashboardDetails?.completedProject /
                    dashboardDetails?.totalProject) *
                  100
                ).toFixed(0),
              )}
              color="#10B981"
              dimesioning="#D1FAE5"
            />
          </div>
        </div>
        <div className="lg:col-span-1">
          <InspectorData
            totalInspectors={dashboardDetails?.totalInspector}
            activeInspectors={dashboardDetails?.activeInspector}
            inactiveInspectors={dashboardDetails?.inactiveInspector}
          />
        </div>
      </div>
      <div>
        <WeldingOperatorStatics />
      </div>
    </div>
  );
};
export default Dashboard;
